import CreatorNewMessageResponsePage from "./CreatorNewMessageResponsePage";

export default CreatorNewMessageResponsePage;
